<h2 mat-dialog-title>{{eventDetails?.title}}</h2>
<mat-dialog-content class="mat-typography">
  <h4>{{eventDetails?.period}}</h4>
  <h4>{{eventDetails?.startingTime}}</h4>
  <h4>{{eventDetails?.endTime}}</h4>
</mat-dialog-content>
<mat-dialog-content [innerHTML]="eventDetails?.description"></mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button mat-dialog-close>Chiudi</button>
</mat-dialog-actions>